import { Filter, Tag } from 'lucide-react';

interface CategoryFilterProps {
  selectedCategory: 'all' | 'venda' | 'redirecionamento';
  onCategoryChange: (category: 'all' | 'venda' | 'redirecionamento') => void;
  stats?: {
    venda: number;
    redirecionamento: number;
  };
}

export default function CategoryFilter({ selectedCategory, onCategoryChange, stats }: CategoryFilterProps) {
  return (
    <div className="bg-white rounded-lg shadow p-4 mb-4">
      <div className="flex items-center gap-2 mb-3">
        <Filter className="w-4 h-4 text-gray-600" />
        <h3 className="font-medium text-gray-900">Filtrar por Categoria</h3>
      </div>
      
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onCategoryChange('all')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            selectedCategory === 'all'
              ? 'bg-blue-500 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Tag className="w-4 h-4" />
          Todas
          {stats && (
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              selectedCategory === 'all' ? 'bg-blue-600' : 'bg-gray-200'
            }`}>
              {stats.venda + stats.redirecionamento}
            </span>
          )}
        </button>

        <button
          onClick={() => onCategoryChange('venda')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            selectedCategory === 'venda'
              ? 'bg-green-500 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          💰 Venda
          {stats && (
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              selectedCategory === 'venda' ? 'bg-green-600' : 'bg-gray-200'
            }`}>
              {stats.venda}
            </span>
          )}
        </button>

        <button
          onClick={() => onCategoryChange('redirecionamento')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            selectedCategory === 'redirecionamento'
              ? 'bg-orange-500 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          🔄 Redirecionamento
          {stats && (
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              selectedCategory === 'redirecionamento' ? 'bg-orange-600' : 'bg-gray-200'
            }`}>
              {stats.redirecionamento}
            </span>
          )}
        </button>
      </div>

      {selectedCategory !== 'all' && (
        <div className="mt-3 text-sm text-gray-600">
          {selectedCategory === 'venda' && (
            <p>📊 Mostrando apenas conversas de <strong>venda</strong></p>
          )}
          {selectedCategory === 'redirecionamento' && (
            <p>📊 Mostrando apenas conversas de <strong>redirecionamento</strong></p>
          )}
        </div>
      )}
    </div>
  );
}
